import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import '../style/common/ConfirmModal.scss'
import { Box } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { navigationWithArrow } from '../utils/helpers';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function ConfirmModal(props) {
    const { onClose, open, cancelRequired = true, dialogConfirmationMessage = 'Are Your Sure ?', showTitle = true, width = 'auto', okButton = 'Yes', cancelBtn = 'No', ...other } = props;

    const handleCancel = () => {
        onClose(false);
    };

    const handleOk = () => {
        onClose(true);
    };

    return (
        <Dialog
            sx={{
                boxShadow:'none',
                '& .MuiDialog-paper': { width: width, maxHeight: 435, borderRadius: '8px' },
                '& .MuiDialogContent-root': {
                    borderTop: 'none'
                }
            }}
            maxWidth="xs"
            className='confirmModal'
            TransitionComponent={Transition}
            open={open}
            {...other}
        >
            <DialogContent dividers>
                <div className='info-icon'>
                    <HelpIcon />
                </div>
                <div className='dialog-msg'>
                    {dialogConfirmationMessage}
                </div>
            </DialogContent>
            <DialogActions>
                <Box className='btnSection'>
                    {cancelRequired && <div className="dialog-btn"><Button autoFocus id='dialogBtnCancel' onClick={handleCancel}
                        onKeyDown={(event) => {
                            navigationWithArrow(event, 'dialogbtnOk', 'dialogbtnOk', () => {
                                handleCancel()
                            })
                        }}
                    >{cancelBtn}</Button></div>}
                    <div className="dialog-btn"><Button id='dialogbtnOk' onClick={handleOk}
                        onKeyDown={(event) => {
                            navigationWithArrow(event, 'dialogBtnCancel', 'dialogBtnCancel', () => {
                                handleOk()
                            })
                        }}

                    >{okButton}</Button></div>
                </Box>
            </DialogActions>
        </Dialog>
    );
}

ConfirmModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default ConfirmModal;